import { get,post } from "../ajax";

export interface ChannelListResType{
    id: number,
    merchantId: number,
    name: string,
    createTime: string,
    updateTime: string,
    remark: string 
}
export async function channelList(body:Record<string, any>){
    const url = `/api/SupplyChannel/GetSupplyChannelPageList?Name=${body.Name}&PageIndex=${body.PageIndex}&PageSize=${body.PageSize}`
    const res = await get(url)
    return res;
}

export async function saveChannel(body:{id:number,name:string,remarks:string}){
    const url = `/api/SupplyChannel/SaveSupplyChannel`
    const res = await post(url,body)
    return res;
}


export async function supplyChannelAppList(){
    const url = `/api/SupplyChannel/GetSupplyChannelAppList`
    const res = await get(url)
    return res;
}